import classNames from 'classnames';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import React from 'react';
import { Routes } from 'routes';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { NextLink, NextLinkTr } from 'components/blocks/NextLink';
import { IResortPageSnowInfo, IResortPathInfo } from 'api/resort/types';
import { SHORT_DATE_FORMAT, formatDateFromStr } from 'util/formatDate';
import { useIsPermanentlyClosed } from 'util/useIsPermanentlyClosed';
import { useBrandfolderOptimizedImage } from 'util/useBrandfolderOptimizedImage';
import styles from './styles.module.scss';

export interface IProps {
  overview: string;
  pathInfo: IResortPathInfo;
  fullResort: IResortPageSnowInfo;
}

export const ResortOverview = ({
  overview, pathInfo, fullResort,
}: IProps) => {
  const { t } = useOTSTranslation('common');

  // remove all html tags from string
  const overViewText = overview.replace(/(<([^>]+)>)/gi, '');

  const isPermanentlyClosed = useIsPermanentlyClosed(fullResort);

  const imageUrl = fullResort.image && useBrandfolderOptimizedImage(fullResort.image);

  return (
    <BoxWithShadow>
      <BlockHeader useH3 title={t('resort.skiReport.resortOverview')}>
        <NextLinkTr href={Routes.resortTripPlanningOverview(pathInfo)} data-click-id="resort-report-overview">
          {t('resort.overview.overviewTab')}
        </NextLinkTr>
      </BlockHeader>
      <BlockContent>
        {imageUrl && (
        <div className={classNames(styles.img)}>
          <NextLink href={Routes.resortTripPlanningOverview(pathInfo)} data-click-id="resort-report-overview">
            <img src={imageUrl} alt="hero" />
          </NextLink>
        </div>
        )}

        <div className={styles.opening}>
          <div className={styles.item}>
            <span className={classNames('h3', styles.h3)}>
              {isPermanentlyClosed ? t('common.na') : formatDateFromStr(fullResort.status.openingDate, SHORT_DATE_FORMAT)}
            </span>
            <div>{ t('resort.skiReport.projectedOpening')}</div>
          </div>
          <div className={styles.item}>
            <span className={classNames('h3', styles.h3)}>
              {isPermanentlyClosed ? t('common.na') : formatDateFromStr(fullResort.status.closingDate, SHORT_DATE_FORMAT)}
            </span>
            <div>{t('resort.skiReport.projectedClosing')}</div>
          </div>
        </div>

        <div className={classNames(styles.text)} dangerouslySetInnerHTML={{ __html: overViewText }} />
        <div>
          {' '}
          <NextLinkTr href={Routes.resortTripPlanningOverview(pathInfo)} data-click-id="resort-report-overview">
            {t('resort.overview.readMore')}
          </NextLinkTr>
        </div>
      </BlockContent>
    </BoxWithShadow>
  );
};
